<template lang="pug">
  span
    v-icon(small) person
    | {{ data[dataKey] }}
</template>

<script>
import GetItem from '@/Core/mixins/getItem';

export default {
  mixins: [GetItem],
  props: {
    data: {
      type: Object,
    },
    dataKey: {
      type: String,
    },
  },
};
</script>
